module.exports = __webpack_public_path__ + "img/rejected.8e32491e.svg";